// extracted by mini-css-extract-plugin
export default {"result":"result_result__E71yJ","result__content":"result_result__content__C7aA9","result__text":"result_result__text__dHZJB","result__amount":"result_result__amount__GfvN0"};